import { render } from "./CreateReportConfirm.vue?vue&type=template&id=5726efd6"
import script from "./CreateReportConfirm.vue?vue&type=script&lang=js"
export * from "./CreateReportConfirm.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src2367962886/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__